import { useEffect, useRef, useState } from "react";
import "./assets/styles/HomePage.css";
import StartAnimation from "./components/StarAnimation";
import Swal from "sweetalert2";
import Congrat from "./components/congrat/Congrat";
import captchaGenerator from "./components/captchaGenerator";
import logo_mb from "./assets/images/logo.png";
import submit_btn_k36 from "./assets/images/btn.png";
import title_mb from "./assets/images/title-mb.png";
import bottom_left from "./assets/images/bottom-left.png";
import bottom_right from "./assets/images/bottom-right.png";

import input_item_left from "./assets/images/nuoc.png";
import input_item_right from "./assets/images/san-ho.png";

import { addPointClient, getCodeClient } from "./services/api.service";
import moment from "moment-timezone";

import { information } from "./information";
import Notify from "./components/Notification/Notify";
import btnBack from "./assets/images/btn_back.png";
import ReCAPTCHA from "react-google-recaptcha";
import ReactDOM from "react-dom";
const HomePage = () => {
  const [point, setPoint] = useState(0);
  const [playerID, setPlayerID] = useState("");
  const [status, setStatus] = useState(false);

  const captchaTokenRef = useRef(null);

  const handleCaptchaGGChange = (token) => {
    captchaTokenRef.current = token;
  };

  useEffect(() => {
    document.getElementById("submit-btn").addEventListener("click", () => {
      let codeID = document.getElementById("code-id").value.replace(/\s/g, "");
      if (codeID === "") {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: "Vui lòng nhập đầy đủ thông tin!",
        });
      } else {
        if (
          document.getElementById("submit-btn").getAttribute("click-id") ===
          "false"
        ) {
          document
            .getElementById("submit-btn")
            .setAttribute("click-id", "true");
          Swal.fire({
            title: "Xác thực",
            showConfirmButton: false,
            allowOutsideClick: false,
            html: `<div class="input-form-captcha-wrapper"><div id="captcha" class="notranslate" translate="no"></div><div class="input-form-captcha"><input class="notranslate" translate="no" type="text" placeholder="Nhập mã captcha" id="captcha-input"></input></div></div>`,
          });
          captchaGenerator("captcha", "captcha-input", codeID);
        }
      }
    });
  }, []);
  const handle_click = () => {
    let codeID = document
      .getElementById("code_string")
      .value.replace(/\s/g, "");

    if (codeID === "") {
      Swal.fire({
        icon: "error",
        title: "Vui lòng nhập mã nhận quà",
        color: "#000",
        background: `linear-gradient(#FFEFE7,#e7d8d8)`,
        customClass: {
          popup: "pop-test",
        },
      });
    } else {
      Swal.fire({
        title: "Xác thực",
        showConfirmButton: false,
        allowOutsideClick: false,
        html: `
          <div class="input-form-captcha-wrapper">
          <div id="captcha"></div>
          <div class="input-form-captcha">
            <input type="text" placeholder="Nhập mã captcha" id="captcha-input"></input>
          </div>
        </div>
          `,
      });
      let capValue = makeid();
      let captcha = document.getElementById("captcha");
      let captchaInput = document.getElementById("captcha-input");

      captcha.innerHTML = capValue;

      captchaInput.addEventListener("input", async () => {
        if (captchaInput.value.length > 3) {
          if (captchaInput.value === capValue) {
            captchaInput.disabled = true;
            captchaInput.classList.remove("background-input-select");

            Swal.fire({
              text: "Đang kiểm tra ...",
              allowOutsideClick: false,
              background: `linear-gradient(#FFEFE7,#e7d8d8)`,
              width: 300,
              didOpen: () => {
                Swal.showLoading();
              },
            });

            let codeResult = await getCodeClient(codeID);
            if (codeResult.status_code === 403) {
              let time = moment(codeResult.detail.time)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MM/YYYY, H:mm:ss");
              Swal.fire({
                icon: "error",
                allowOutsideClick: false,
                title: codeResult.title_mess,
                background: `linear-gradient(#FFEFE7,#e7d8d8)`,
                html:
                  "<div class='modal-text-wrapper'>" +
                  "<div class='modal-text-cont'>" +
                  "<p class='modal-text'>Mã khuyến mãi: &nbsp;</p>" +
                  "<p style='font-weight: 600'>" +
                  codeResult.detail.promo_code +
                  "</p>" +
                  "</div>" +
                  "<div class='modal-text-cont'>" +
                  "<p class='modal-text'>Điểm thưởng: &nbsp;</p>" +
                  "<p style='font-weight: bold; color:#ec164c'>" +
                  codeResult.detail.point +
                  "&nbsp; điểm</p>" +
                  "</div>" +
                  // "<div class='modal-text-cont'>" +
                  // "<p class='modal-text'>" +
                  // codeResult.detail.mess +
                  // " : &nbsp;</p>" +
                  // "<p style='font-weight: 600'>" +
                  // time +
                  // "</p>" +
                  // "</div>" +
                  "</div>",
                footer:
                  '<a href="' +
                  information?.cskh_url +
                  '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng</a>',
              }).then(() => {
                window.location.reload();
              });
            } else {
              if (codeResult.valid === false) {
                Swal.fire({
                  icon: "warning",
                  title: codeResult.title_mess,
                  text: codeResult.text_mess,
                  background: `linear-gradient(#FFEFE7,#e7d8d8)`,
                  footer:
                    '<a href="' +
                    information?.cskh_url +
                    '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng.</a>',
                }).then(() => {
                  window.location.reload();
                });
              } else if (codeResult.valid === true) {
                let time = moment(codeResult.detail.time)
                  .tz("Asia/Ho_Chi_Minh")
                  .format("DD/MM/YYYY, H:mm:ss");
                Swal.close();
                setPoint(codeResult?.detail?.point);
                Swal.fire({
                  icon: "success",
                  title: codeResult.title_mess,
                  allowOutsideClick: false,
                  background: `linear-gradient(#FFEFE7,#e7d8d8)`,
                  html:
                    "<div class='modal-text-wrapper'>" +
                    "<div class='modal-text-cont'>" +
                    "<p class='modal-text'>Mã khuyến mãi: &nbsp;</p>" +
                    "<p style='font-weight: 600'>" +
                    codeResult.detail.promo_code +
                    "</p>" +
                    "</div>" +
                    "<div class='modal-text-cont'>" +
                    "<p class='modal-text'>Điểm thưởng: &nbsp;</p>" +
                    "<p style='font-weight: bold; color:#ec164c'>" +
                    codeResult.detail.point +
                    "&nbsp; điểm</p>" +
                    "</div>" +
                    "<div class='modal-text-cont'>" +
                    "<p class='modal-text'>" +
                    codeResult.detail.mess +
                    " : &nbsp;</p>" +
                    "<p style='font-weight: 600'>" +
                    time +
                    "</p>" +
                    "</div>" +
                    "<div id='captcha-container' class='captcha-gg'></div></div>",
                  footer:
                    '<a href="' +
                    information?.cskh_url +
                    '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng</a>',
                  input: "text",
                  inputLabel: "Vui lòng nhập tên tài khoản để nhận thưởng",
                  inputPlaceholder: "Tên tài khoản",
                  showCancelButton: true,
                  confirmButtonText: "Xác nhận",
                  cancelButtonText: "Hủy",
                  didOpen: () => {
                    const captchaContainer =
                      document.getElementById("captcha-container");
                    if (captchaContainer) {
                      const recaptchaElement = document.createElement("div");
                      captchaContainer.appendChild(recaptchaElement);
                      const recaptchaInstance = (
                        <ReCAPTCHA
                          sitekey="6Lf8CvcqAAAAAD--oLuOdHbdBOXfpVMZoBL9giAa"
                          hl="vi"
                          onChange={handleCaptchaGGChange}
                        />
                      );
                      ReactDOM.render(recaptchaInstance, recaptchaElement);
                    }
                  },
                  preConfirm: () => {
                    if (!captchaTokenRef.current) {
                      return Swal.showValidationMessage(
                        "Vui lòng xác nhận bạn không phải là robot!"
                      );
                    }
                  },
                  inputValidator: async (playerID) => {
                    if (!playerID || !captchaTokenRef.current) {
                      return "Vui lòng kiểm tra lại thông tin đầu vào!";
                    } else {
                      setPlayerID(playerID);
                      Swal.fire({
                        text: "Đang cộng điểm ...",
                        background: `linear-gradient(#FFEFE7,#e7d8d8)`,
                        allowOutsideClick: false,
                        width: 300,
                        didOpen: () => {
                          Swal.showLoading();
                        },
                      });

                      let addPoint = await addPointClient(
                        playerID,
                        codeResult.detail.promo_code,
                        captchaTokenRef.current
                      );
                      if (addPoint.status_code === 502) {
                        Swal.fire({
                          icon: "warning",
                          title: addPoint.title_mess,
                          text: addPoint.text_mess,
                          background: `linear-gradient(#FFEFE7,#e7d8d8)`,
                          footer:
                            '<a href="' +
                            information?.cskh_url +
                            '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng.</a>',
                        }).then(() => {
                          window.location.reload();
                        });
                      } else {
                        if (addPoint.valid === false) {
                          Swal.fire({
                            icon: "error",
                            title: addPoint.title_mess,
                            text: addPoint.text_mess,
                            background: `linear-gradient(#FFEFE7,#e7d8d8)`,
                            footer:
                              '<a href="' +
                              information?.cskh_url +
                              '" target="_blank">Liên Hệ Chăm Sóc Khách Hàng.</a>',
                          }).then(() => {
                            window.location.reload();
                          });
                        } else if (addPoint.valid === true) {
                          console.log("Done");
                          setStatus(true);

                          const Toast = Swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                          });
                          Toast.fire({
                            icon: "success",
                            title: "Cộng điểm thành công",
                          });
                        }
                      }
                    }
                  },
                });
              }
            }
          }
        }
      });
    }
  };

  return (
    <>
      <div>
        <Notify />
      </div>
      <div id="home-page" className="bg-k36">
        <div
          className="btn-back btn-back-history"
          onClick={() => window.history.back()}
        >
          <img src={btnBack} className="image-back-history" alt="Trở lại" />
        </div>
        <div className="warpper">
          <a
            href={information?.nav_url}
            className="box-logo"
            title="Trang chủ Jun88"
          >
            <img className="logo-mb" src={logo_mb} alt="" />
          </a>
          <div className="box-img">
            <a
              href={information?.nav_url}
              className="box-title"
              title="Trang chủ Jun88"
            >
              <img className="img-title" src={title_mb} alt="" />
            </a>
            <div className="input-cont input-cont-k36">
              <div className="input-item-cont">
                <input
                  id="code_string"
                  type="text"
                  placeholder="Nhập code tại đây  "
                  autoComplete="off"
                ></input>
              </div>
              <div id="submit-btn" click-id="false">
                <img
                  className="submit-btn-k36"
                  alt=""
                  src={submit_btn_k36}
                  onClick={handle_click}
                />
              </div>
              <div className="input-item-left">
                <img src={input_item_left} alt="" />
              </div>
              <div className="input-item-right">
                <img src={input_item_right} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-bottom-left">
          <img src={bottom_left} alt="" />
        </div>
        <div className="bg-bottom-right">
          <img src={bottom_right} alt="" />
        </div>
        {<StartAnimation status={status} />}
        <Congrat status={status} playerID={playerID} point={point} />
      </div>
    </>
  );
};

export default HomePage;
function makeid() {
  let text = "";
  let possible = "0123456789abcdefghijklmnopqrstuvwxyz";
  for (let i = 0; i < 4; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}
